/* @flow */

import * as Yup from 'yup'

import WebshopGridSettings from './WebshopGridSettings'
import WebshopGrid from './WebshopGrid'
import { LAYOUT_OPTIONS } from './shared'
import {
  type LayoutSetting,
  type ColumnWidthSettingItem,
  type RowHeightSettingItem,
} from './shared'

type WidgetSettings = {
  layout: LayoutSetting | null,
  custom_number_of_columns: number,
  custom_number_of_rows: number,
  column_widths: Array<ColumnWidthSettingItem>,
  row_heights: Array<RowHeightSettingItem>,
  column_gap: number,
  row_gap: number,
  stack_on_mobile: boolean,
}

const widget = {
  component: WebshopGrid,
  settings: WebshopGridSettings,

  available_children: [
    'banner',
    'centered_content',
    'container',
    'drop_link',
    'grid',
    'link_button',
    'product_carousel',
    'text',
  ],
  label: 'Grid',

  default_settings: ({
    layout: null,
    custom_number_of_columns: 2,
    custom_number_of_rows: 2,
    column_widths: [],
    row_heights: [],
    column_gap: 20,
    row_gap: 20,
    stack_on_mobile: true,

    max_width_mode: 'fixed',
    fixed_max_width: null,
    percentage_max_width: null,
  }: WidgetSettings),

  default_style: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
    paddingBottom: 0,

    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    marginBottom: 0,
  },

  settings_validation: Yup.object().shape({
    data: Yup.object().shape({
      layout: Yup.string()
        .required('Select one of the layout options')
        .oneOf(
          LAYOUT_OPTIONS.map(o => o.value),
          'Select one of the layout options'
        ),

      column_widths: Yup.array().of(
        Yup.object().shape({
          mode: Yup.string().oneOf(['dynamic', 'fixed']),
          dynamic_value: Yup.number().when('mode', {
            is: 'dynamic',
            then: Yup.number()
              .typeError('Must be integer')
              .required('Must be integer')
              .integer('Must be integer')
              .min(1, 'Must be 1 or more'),
          }),
          fixed_value: Yup.number().when('mode', {
            is: 'fixed',
            then: Yup.number()
              .typeError('Must be integer')
              .required('Must be integer')
              .integer('Must be integer')
              .min(1, 'Must be 1 or more'),
          }),
        })
      ),
      row_heights: Yup.array().of(
        Yup.object().shape({
          mode: Yup.string().oneOf(['auto', 'fixed']),
          fixed_value: Yup.number().when('mode', {
            is: 'fixed',
            then: Yup.number()
              .typeError('Must be integer')
              .required('Must be integer')
              .integer('Must be integer')
              .min(1, 'Must be 1 or more'),
          }),
        })
      ),

      column_gap: Yup.number()
        .typeError('Must be integer')
        .required('Must be integer')
        .integer('Must be integer')
        .min(0, 'Must be 0 or more'),
      row_gap: Yup.number()
        .typeError('Must be integer')
        .required('Must be integer')
        .integer('Must be integer')
        .min(0, 'Must be 0 or more'),
    }),
  }),
}

export default widget
